<template>
 <div>
        <div style="height: 700px; overflow: auto;">
        <el-tag type="danger" size="medium">搜索结果只针对当前页，如需搜索更多或未找到小红盟，请翻页搜索</el-tag>
    <el-input v-model="keyword" placeholder="请输入小红盟关键词"></el-input>
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
      <el-table :data="filteredData" v-loading="loading" style="width: 100%"   border>
        <el-table-column prop="taskName" label="任务名称"> 
        </el-table-column>
         <el-table-column prop="taskStartTime" label="任务开始时间"> 
        </el-table-column>
         <el-table-column prop="finishTime" label="任务结束时间"> 
        </el-table-column>

          <el-table-column prop="contacts" label="联系电话"> 
        </el-table-column>
                  <el-table-column prop="statusText" label="状态"> 
        </el-table-column>
        <el-table-column label="操作" align="center" width="380">
        <template slot-scope="scope">
        <template v-if="scope.row.statusText !== '未开始'">
              <span class="handel" @click="getMxXhmStat(scope.row)">查看详情</span>
              </template>
              </template>
        </el-table-column>
      </el-table>
</div>
</div>
</template>
<script>
import { getMxXhm } from "@/api/xhm";
import router from '@/router';
  export default {
    data() {
      return {
      tableData: [],
      currentPage: 1,
      pageSize: 50,
      total: 0,
      keyword:'',
      loading: false
      };
    },
  mounted() {
    this.search();
  },
computed: {
  
    filteredData() {
      if (this.keyword === '') {
        return this.tableData;
      } else {
        return this.tableData.filter(item => item.taskName.includes(this.keyword));
      }
    }
  },
    methods: {
      async search(val){
        this.loading = true;
        await getMxXhm({
          pageNo: this.currentPage, 
          pageSize: this.pageSize
          }).then((res) => {
            this.loading = false;
            if (res.code == 1000) {
     this.tableData = res.data.result;
      this.total = res.data.totalNum;
          }else {
          this.$message({
            message: res.msg,
            type: "warning",
          });
        }

      })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search(); // 重新搜索以更新分页数据
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search(); // 重新搜索以更新分页数据
    },
    getMxXhmStat(val) {

      let routeData = router.resolve({ name: `麦炫小红盟每日数据`,　　　　
        query: {
          
          taskId: val.taskId,
          taskName:val.taskName,
        } }) 
         window.open(routeData.href, '_blank');
    },
    }
};
</script>

